export default __webpack_public_path__ + "static/media/Deodorant.40f88450.jpeg";